import React from 'react';
import styled, { css } from 'styled-components';
import { Type, IconCheck } from '@spotify-internal/encore-creator-web';

import { Subcategory } from '../../../types';

const SubcategoryListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const SubCategoryButton = styled.div<{ selected: boolean }>`
  align-items: center;
  background: white;
  border: 1px solid #bdbdbd;
  border-radius: 5px;
  color: #bdbdbd;
  display: flex;
  margin: 0 16px 16px 0;
  padding: 10px 16px;
  min-width: min-content;

  &:hover {
    color: black;
    border-color: black;
  }
  ${props =>
    props.selected &&
    css`
      background: black;
      border-color: black;
      color: #eeeeee;

      &:hover {
        color: #eeeeee;
      }
    `};
`;

export const SubcategoryLimit = 3;

interface Props {
  value: Set<Subcategory>;
  subcategories: Subcategory[];
  onSelect(subcategories: Set<Subcategory>): void;
}

export function SubcategoryPicker(props: Props) {
  const [count, setCount] = React.useState(0);

  function toggleSubcategory(subcategory: Subcategory) {
    if (props.value.has(subcategory)) {
      props.value.delete(subcategory);
      setCount(count - 1);
    } else if (count < SubcategoryLimit) {
      props.value.add(subcategory);
      setCount(count + 1);
    }

    const changes = new Set(props.value);
    props.onSelect(changes);
  }

  return (
    <SubcategoryListContainer data-testid="subcategory-list">
      {props.subcategories.map(subcategory => {
        const active = props.value.has(subcategory);
        return (
          <SubCategoryButton
            data-testid={`subcategory-${subcategory.value}`}
            key={subcategory.value}
            onClick={() => toggleSubcategory(subcategory)}
            selected={active}
          >
            <Type.p variant={Type.body2} condensed style={{ marginRight: '20px' }}>
              {subcategory.name}
            </Type.p>
            <IconCheck iconSize={16} color={active ? 'gray75' : 'white'} />
          </SubCategoryButton>
        );
      })}
    </SubcategoryListContainer>
  );
}
